import Typography from "@material-ui/core/Typography"
import React from "react"
import withSimpleErrorBoundary from "../util/withSimpleErrorBoundary"

const Notice = (props) => {
  return (
    <Typography color="error" variant="title">
      {props.children}
    </Typography>
  )
}

export default withSimpleErrorBoundary(Notice)
